<template>
  <div class="loginmy">
    <div class="loginmy-img">
      <!--      <div class="titlezh">阿启泰文化艺术大数据优质资源库</div>-->
      <!--      <div class="titlemn ">-->
      <!--        <p class="aqt_lang_mn">{{$t('m.aqt_whysdsjyzzy')}}</p>-->
      <!--      </div>-->
      <img v-if="!$route.query.lib_type||$route.query.lib_type=='aqt'" src="@/assets/images/login_img/wenzi2.png"
           alt="">
    </div>
    <div class="loginmy-con">
      <Card icon="log-in" title="登录" :bordered="false">
        <div class="form-con">
          <Form ref="form" :model="form" :rules="rules" @keydown.enter.native="handleSubmit('form')">
            <FormItem label="语言" style="display: -webkit-box;">
              <RadioGroup v-model="form.lang">
                <Radio :label="'zh'">中文</Radio>
                <Radio :label="'mn'">蒙古文</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem prop="iphone">
              <Input @on-blur="getcollection" prefix="md-phone-portrait" v-model="form.iphone" placeholder="请输入手机号"/>
            </FormItem>

            <FormItem prop="library_id">
              <Select :disabled="options.length?false:true" prefix="md-pricetags" v-model="form.library_id"
                      style="width:260px" filterable placeholder="请选择馆藏">
                <Option v-for="item in options" :value="item.library_id" :key="item.library_id">{{ item.text }}</Option>
              </Select>
            </FormItem>

            <FormItem prop="code">
              <Input class="inputVercod" prefix="md-checkmark-circle" v-model="form.code"
                     placeholder="请输入验证码"/>
              <Button class="code" :disabled="Prohibit"
                      @click="GetVerificationCode">{{ text }}
              </Button>
            </FormItem>
            <FormItem>
              <Button @click="handleSubmit('form')" :loading="loading" type="primary" long>登录</Button>
            </FormItem>
          </Form>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
const axios = require('axios')
export default {
  data() {
    return {
      loading: false,
      form: {
        code: '',
        iphone: '',
        library_id: '',
        lang: 'mn'
      },
      checkCode: '',
      rules: {
        iphone: [
          {required: false, message: '请输入手机号', trigger: 'blur'},
          {pattern: /^1[3456789]\d{9}$/, message: "手机号码格式不正确", trigger: "blur"}
        ],
        code: [
          {required: false, trigger: 'blur', message: '请输入验证码',}
        ],
        library_id: [
          {required: false, type: 'number', trigger: 'change', message: '请输选择馆藏',}
        ]
      },
      userUrl: 'api/web/v1/member/find',


      data: {
        tel: "",
      },
      value: "" /**文本 */,
      codes: "" /**验证验证码 */,
      possword: "" /**密码 */,
      onepossword: "" /**确认密码 */,
      Prohibit: false /**按钮禁用 */,
      text: "获取验证码" /**按钮文字 */,
      protocol_data: [], // 关于我们数据
      checked: false,
      tels: "" /**验证手机号 */,

      options: [],//馆藏列表
    }
  },
  methods: {

    /************************************************************
     *
     * 验证码倒计时
     *
     ************************************************************/
    GetVerificationCode() {
      var that = this;

      that.saveUserBehavior(0, '点击获取验证码', 0, that.form.library_id)
      if (that.form.iphone == "") {
        //填写手机号
        that.$Message.error(that.$t('m.mobile_Please'));
        return;
      }
      if (that.form.iphone.length != 11 || isNaN(Number(that.form.iphone))) {
        //请填写正确电话号码
        that.$Message.error(that.$t('m.telephone_Please'));
        return;
      }
      var num = 60;
      if (that.Prohibit) {
        return;
      }

      function qiehan() {
        if (num > 1) {
          --num;
          that.text = "等" + num + "秒";
          that.Prohibit = true;
          setTimeout(function () {
            qiehan();
          }, 1000);
        } else {
          that.text = "获取验证码";
          that.Prohibit = false;
        }
      }

      qiehan();
      let a = {
        tel: that.form.iphone,
      };
      that.$http
          .post("api/web/v1/Alisms/code", a)
          .then((val) => {
            that.codes = val.data;
            that.tels = a.tel
          })
          .catch((err) => {
            //发送验证码太频繁，请1小时后再试！
            that.$Message.error(that.$t('m.code_to_frequently'));
          });
    },

    /*****************************************************************
     *
     * 表单验证
     * @param   {name}             表单
     *
     *****************************************************************/
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.loading = true
          this.login()
        } else {
          // this.$Message.error('请检查输入内容!')
        }
      })
    },

    /*****************************************************************
     *
     * 登录
     *
     *****************************************************************/
    async login() {
      const that = this
      // var num = localStorage.getItem('uuid')
      //||that.form.iphone == "13451318702"
      var pd;
      if ((that.form.iphone == "15560717061" || that.form.iphone == "18204498923") && that.form.code == "666666") {
        pd = false;
      } else {
        pd = true;
      }

      if (that.form.iphone.length != 11 || isNaN(parseInt(that.form.iphone))) {
        //请填写正确电话号码
        that.$Message.warning(that.$t('m.telephone_Please'));
        that.loading = false
        return;
      }
      if (pd) {
        if (that.tels != that.form.iphone) {
          //获取验证码手机号和输入手机号不一致
          that.$Message.warning(that.$t('m.code_is_inconsistent'));
          that.loading = false
          return;
        }
      }

      if (that.form.code == "") {
        //请填写验证码
        that.$Message.warning(that.$t('m.verification_code_Please'));
        that.loading = false
        return;
      }
      if (that.form.library_id == "") {
        //请选择馆藏
        that.$Message.warning(that.$t('m.collection_Please'));
        that.loading = false
        return;
      }
      if (pd) {
        if (that.codes != that.form.code) {
          //验证码不正确
          that.$Message.warning(that.$t('m.code_Incorrect'));
          that.loading = false
          return;
        }
      }
      let libbymber = null
      if (that.options.length) {
        let libObjt = that.options.find(e => e.library_id == that.form.library_id)
        libbymber = libObjt && libObjt.value ? libObjt.value : ''
      }
      that.saveUserBehavior(0, '点击登录按钮', 0, that.form.library_id)
      const data = {
        tel: that.form.iphone,
        lang: that.form.lang,
        appway: 14,//终端类型 1 书籍app 2文库app 3书籍小程序 4书籍墨水屏 5朗读亭 6系统管理端 7自助借还机 8微型图书馆 9书籍查阅机 10电子阅读机 11文库墨水屏 12文库小程序  13阿启泰有声读物小程序 14优质资源 15蒙医药
        device_number: this.$uuid.v4(),
        permission: '2',//资源权限资源权限 1书籍文献 2优质资源 3蒙医药 4有声读物 5民间艺术
        library_id: that.form.library_id,
        number: libbymber,
      };
      that.$httpsencrypt.post("api/web/v3/login/telloginspcnew", data)
          .then((val) => {
            let ff = {
              member_id: val.data.member_id,
            };
            localStorage.removeItem("userInfoMemberId");
            localStorage.setItem("userInfoMemberId", that.$crypto.set(JSON.stringify(ff)));
            localStorage.setItem("userInfos", that.$crypto.set(JSON.stringify(val.data)));

            localStorage.removeItem("lang");
            localStorage.setItem("lang", that.form.lang);
            that.$store.dispatch('getLangStore', that.form.lang).then(() => {
            })

            that.getCollectionInfor(val.data.type)

          }).catch((err) => {
        that.loading = false

      });
    },

    /*****************************************************************
     *
     * 用户信息
     *
     *****************************************************************/
    userData(id) {
      const _this = this;
      _this.$http.get(`api/web/v1/member/find?member_id=` + id)
          .then((val) => {
            // _this.infoname = val.data;
            localStorage.setItem("userInfos", _this.$crypto.set(JSON.stringify(val.data)));
            if (sessionStorage.getItem('gcm') == 'school') {
              _this.$router.replace({path: '/External', query: {lib_type: sessionStorage.getItem('gcm')}})
            } else {
              _this.$router.replace({path: '/aqt', query: {lib_type: sessionStorage.getItem('gcm')}})
            }

            _this.loading = false
          }).catch((err) => {
        //    页面溜走了，请稍后重试！
        _this.$Message.warning(_this.$t('m.page_away'))
        _this.loading = false
      });

    },
    /*****************************************************************
     *
     * 获取馆藏信息
     *
     *****************************************************************/
    getCollectionInfor(number) {
      let that = this
      that.$http.post('api/web/v1/library/search/' + number)
          .then((val) => {
            let a = {
              library_num: number,
              protocol: val.data.protocol,
              library_id: val.data.library_id,
              theme_color: val.data.theme_color,
              personal_pic: val.data.personal_pic,
              sidebar_pic: val.data.sidebar_pic,
              details_pic: val.data.details_pic,
              logo_icon: val.data.logo_icon,
              lat: val.data.lat,
              lon: val.data.lon,
              range: val.data.range,
              QRcode: val.data.QRcode,
              name_lang: val.data.name_lang
            }
            localStorage.setItem('theme_color', that.$crypto.set(JSON.stringify(a)))
            if(localStorage.getItem('lang')=='zh'){
              that.$router.replace({path: '/zhver', query: {lib_type: sessionStorage.getItem('gcm')}})
            }else {
              if (val.data.library_id == 28) {
                if (sessionStorage.getItem('gcm') == 'school') {
                  that.$router.replace({path: '/External', query: {lib_type: sessionStorage.getItem('gcm')}})
                } else {
                  that.$router.replace({path: '/aqt', query: {lib_type: sessionStorage.getItem('gcm')}})
                }

              } else {
                let query = {
                  key_class: '',
                  value_class: '',
                  type_class: 5,
                  Components: 'LayPeriodicalJournal',
                  searchContent: '',
                  startlanguage: '',
                  endlanguage: ''
                }
                that.$router.replace(
                    {
                      path: '/SearchIndex',
                      query: {
                        lib_type: sessionStorage.getItem('gcm'),
                        data: that.$crypto.set(JSON.stringify(query)),
                      }
                    }
                )
              }
            }


            that.loading = false
          })
          .catch(e => {
            that.loading = false
          })
    },
    saveUserBehavior(type, mark, id, library_id) {
      let that = this

      let info = {
        book_id: id,
        magazine_id: null,
        type: type,
        path: this.$route.path,
        mark: mark,
        library_id: library_id,
      }
      that.$store.dispatch('saveUserBehavior', info).then(() => {
      })

    },
    /************************************************************
     *
     *获取馆藏列表数据
     *
     ************************************************************/
    getcollection() {
      let that = this;
      if (!that.form.iphone) {
        return
      }
      let cond = {
        tel: that.form.iphone,
      }
      that.$httpsencrypt
          .post("api/web/v3/library/liblist", cond)
          .then((val) => {
            if (val.code == 200 && val.data.length) {
              that.options = val.data.map((it) => {
                var ff = {
                  text: it.name_lang.zh || it.name_lang.mn,
                  value: it.number,
                  library_id: it.library_id
                }
                return ff
              });
            } else {
              that.options = []
            }

          })
          .catch((err) => {
          });
    },
  },
  created() {
    // this.getcollection()
  }
};
</script>

<style lang="less" scoped>
.loginmy {
  width: 100%;
  height: 100%;
  background-image: url("./../assets/images/login_img/bg.png");
  background-size: 100% 100%;
  background-position: center;
  display: flex;
  justify-content: center;

  &-img {
    height: 100%;
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
      width: auto;
      height: 60%;
      //height: 45%;
    }

    .titlezh {
      width: 100%;
      height: 70px;
      color: #ffffff;
      font-size: 35px;
      font-weight: 600;
      letter-spacing: 5px;
      text-align: center;
      line-height: 70px;
    }

    .titlemn {
      width: 100%;
      height: 83px;
      display: flex;
      justify-content: center;
      overflow: hidden;
      margin-bottom: 10px;

      p {
        color: #ffffff;
        font-size: 25px;
        line-height: 70px;
        font-family: "OrhonCaiyunTig";
      }
    }
  }


  &-con {
    width: 30%;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    &-header {
      font-size: 16px;
      font-weight: 300;
      text-align: center;
      padding: 30px 0;
    }

    .form-con {
      width: 260px;
      padding-bottom: 20px;

      .ivu-form-item {
        margin-bottom: 20px !important;
      }
    }

    .login-tip {
      font-size: 10px;
      text-align: center;
      color: #c3c3c3;
    }

    img {
      width: 305px;
      height: auto;
    }
  }


}
</style>

<style lang="less">
.form-con {
  .ivu-form-item-content {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .inputVercod {
      width: 70%;
    }

    .code {
      width: 28%;
      height: 32px;
      border: 1px solid #ffffff;
      border-radius: 4px;
      font-size: 10px;
      text-align: center;
      color: #045F5B;
      background: #ffffff;
      line-height: 32px;
      cursor: pointer;
      padding: 0;
    }
  }
}

.loginmy {
  .ivu-card {
    //width: 380px;
    height: 330px;
    background: rgba(255, 255, 255, 0.1) !important;
    border: 1px solid rgba(255, 255, 255, 0.4) !important;
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.15) !important;
    border-radius: 6px;
    padding: 0 20px !important;
  }

  .ivu-card-head {
    border: 0px solid #FFFFFF !important;


    p {
      height: 40px;
      display: flex;
      justify-content: center;

      span {
        font-size: 28px;
        font-family: Heiti SC;
        font-weight: 300;
        color: #FBF0D4;
        line-height: 40px;
      }
    }
  }

  .ivu-card-body {
    padding: 0 !important;
  }

  .ivu-btn-primary {
    background: #FFB400 !important;
    box-shadow: 0px 2px 0px 0px #0B5581;

    span {
      color: #ffffff !important;
    }
  }

  .ivu-btn-primary:hover {
    opacity: 0.8 !important;
  }

  .ivu-form-item{
    color: #ffffff!important;
  }
  .ivu-form-item-label{
    color: #ffffff!important;
  }
  .ivu-radio-inner{
    background-color: transparent !important;
  }
  .ivu-radio-checked .ivu-radio-inner{
    border-color:#ffffff!important;
  }
  .ivu-radio-inner:after{
    background-color: #ffffff!important;
  }
}

</style>
